import { format } from 'date-fns';

export const routerPath = {
  root: '/Users-attendance-report-gym-Facility-admin',
};

export const getColumns = () => [
  {
    id: 'month',
    label: 'Month',
    nameForSort: 'year,month',
    customValue: (item) => {
      const d = new Date(2016, item.month - 1);
      return format(d, 'LLLL');
    },
    align: 'left',
  },
  {
    id: 'year',
    label: 'Year',
    nameForSort: 'year,month',
    align: 'center',
  },
  { id: 'entriesBudgeted', label: 'Entries Budgeted', nameForSort: 'budgeted_entries', align: 'center' },
  { id: 'uniqueEntries', label: 'Unique Entries', nameForSort: 'unique_entries', align: 'center' },
  { id: 'uniqueUsers', label: 'Unique Users', nameForSort: 'unique_users', align: 'center' },
  { id: 'averageUserVisit', label: 'Average User Visits', nameForSort: 'avg_visit_per_user', align: 'center' },
  { id: 'excessEntries', label: 'Excess Entries', nameForSort: 'excess_entries', align: 'center' },
  { id: 'excessValue', label: 'Excess Value', nameForSort: 'excess_entry_value', align: 'center' },
];

export const getFilters = ({ yearMount }) => [
  {
    id: 'yearMonth',
    type: 'yearMonth',
    label: 'Year Month',
    value: yearMount.value,
    action: yearMount.change,
  },
];
